import { ca } from '@cian/analytics';

import { EAnalyticsKey } from '../../types/chatHint';
import { TMessagesOfferResponse } from '../../types/messages';

export function trackOpenNoLinksPopup() {
  ca('eventSite', {
    action: 'Open_sopr',
    category: 'Chat',
    label: 'NoLinksPopup',
    name: 'oldevent',
  });
}

interface ITrackFirstMessageSentParams {
  label?: string;
  action?: string;
  gaProducts?: never;
  response: TMessagesOfferResponse;
  userId: number;
  analyticsKey: EAnalyticsKey | null;
}

export function trackFirstMessageSent({
  label,
  action,
  gaProducts,
  response,
  userId,
  analyticsKey,
}: ITrackFirstMessageSentParams) {
  //@ts-expect-error Другого способа получить информацию о странице нет
  const page = window.CianAnalytics.service.config.page || {};

  const {
    data: { offer },
    users,
  } = response;

  const companion = users.find(u => u.userId !== userId);

  const products = gaProducts || [
    {
      id: offer?.cianId,
      offerType: offer ? 'offer' : 'agent',
      ...(offer ? {} : { extra: { recipientid: companion?.userId } }),
    },
  ];

  ca('eventSite', {
    name: 'oldevent',
    category: 'Message_popup',
    action: action || 'send_message',
    label,
    products,
    page: {
      ...page,
      extra: {
        owner_id: userId,
        questionName: analyticsKey,
      },
    },
  });
}
